import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex items-start gap-3" }
const _hoisted_2 = { class: "min-w-[220px]" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Search = _resolveComponent("Search")!
  const _component_MultipleSelectSearch = _resolveComponent("MultipleSelectSearch")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_Search, {
      value: _ctx.customerLeaderboardSearchQuery,
      placeholder: _ctx.$t('dashboard.customerLeaderboardFilter.customerName'),
      onInput: _ctx.onLeaderboardSearch,
      onClear: _ctx.onLeaderboardClear,
      timeout: 300,
      minChar: 0,
      isIconLeft: true,
      isIconClearRight: true
    }, null, 8, ["value", "placeholder", "onInput", "onClear"]),
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_MultipleSelectSearch, {
        dataSelect: _ctx.dataSelect,
        optionsBySearch: _ctx.optionsBySearch,
        isOpenMenu: _ctx.isOpenMenu,
        isDisabled: false,
        isLoading: false,
        placeholder: _ctx.$t('dashboard.customerLeaderboardFilter.allLabels'),
        onOpenSelect: _ctx.onOpenSelect,
        onCloseSelect: _ctx.onCloseSelect,
        onChooseSelect: _ctx.onChooseSelect,
        onTyping: _ctx.onTyping
      }, null, 8, ["dataSelect", "optionsBySearch", "isOpenMenu", "placeholder", "onOpenSelect", "onCloseSelect", "onChooseSelect", "onTyping"])
    ])
  ]))
}